// extracted by mini-css-extract-plugin
module.exports = {"mobileContainerPadding":"PasswordChangePage_mobileContainerPadding__1ZQCl","content":"PasswordChangePage_content__tkYOe","title":"PasswordChangePage_title__xcBmU"};